import { render, staticRenderFns } from "./MyPhotoBooks.vue?vue&type=template&id=dc8a8666"
import script from "./MyPhotoBooks.vue?vue&type=script&lang=js"
export * from "./MyPhotoBooks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports